// src/theme/colors.js
export const colors = {
    // Primary Colors with variations
    primary: {
      main: '#20419a', // Q8 Blue
      light: '#4F53A0', // 80%
      '60': '#7A79B8',
      '40': '#A6A4D2',
      '20': '#D2D0EA',
    },
    secondary: {
      main: '#cc0e00', // Q8 Red
      light: '#EA5040', // 80%
      '60': '#F0826B',
      '40': '#F6B09B',
      '20': '#FBD9CE',
    },
    warning: {
      main: '#ffc61e', // Q8 Yellow
      light: '#FDC750', // 80%
      '60': '#FED683',
      '40': '#FEE3AF',
      '20': '#FFF1D5',
    },
    grey: {
      main: '#67686b',
      light: '#8B888A', // 80%
      '60': '#AAAAAA',
      '40': '#C8C8C8',
      '20': '#E4E4E4',
    },
  
    // Secondary Colors
    secondaryBlue: {
      1: '#0069B4',
      2: '#A5C6EA',
      3: '#01ADDA',
      4: '#A6D9E4',
    },
    secondaryRed: {
      1: '#E62937',
      2: '#F18EA3',
      3: '#AA3339',
    },
    secondaryPurple: {
      1: '#942A86',
      2: '#CAA1CA',
    },
    secondaryGreen: {
      1: '#969200',
      2: '#B9BE15',
    },
    secondaryAqua: {
      1: '#03858C',
      2: '#4CBDCD',
    },
  
    // Gradients
    gradients: {
      blue: 'linear-gradient(to right, #3953a1, #012e63)',
      red: 'linear-gradient(to right, #e62937, #aa3339)',
      yellow: 'linear-gradient(to right, #ffd202, #ea8201)',
      // NFO Gradients
      nfoGestori: 'linear-gradient(to right, #20419a, #FBB907)',
      nfoAppaltatori: 'linear-gradient(to right, #26358C, #CC0C00)',
      // SMS Gradients
      smsNewEnergy: 'linear-gradient(to right, #00ACD9, #20419a)',
      smsMobility: 'linear-gradient(to right, #20419a, #E40520)',
    }
  };